import { createAsyncThunk } from '@reduxjs/toolkit'
import { dashboardServices } from '@services'

export const fetchMenus = createAsyncThunk('dashboard/fetchMenus', async (_, thunk) => {
    try {
        const res = await dashboardServices.fetchMenus()

        if (res.error) {
            return thunk.rejectWithValue(res.error)
        }

        return res.menus
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchCafeConfig = createAsyncThunk('dashboard/fetchCafeConfig', async (_, thunk) => {
    try {
        const response = await dashboardServices.fetchCafeConfig()

        if (response.error) {
            return thunk.rejectWithValue(response.error)
        }

        return response.cafe[0]
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchCafeCashRegisters = createAsyncThunk('dashboard/fetchCafeCashRegisters', async (_, thunk) => {
    try {
        const res = await dashboardServices.fetchCafeCashRegisters()

        if (res.error) {
            return thunk.rejectWithValue('Invalid cafe id')
        }

        return res
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})

export const fetchCafeGroups = createAsyncThunk('dashboard/fetchCafeGroups', async (_, thunk) => {
    try {
        const res = await dashboardServices.fetchCafeGroups()

        if (res.error) {
            return thunk.rejectWithValue('Invalid cafe id')
        }

        return res
    } catch (error) {
        return thunk.rejectWithValue(error.message)
    }
})
